export const FETCH_APP_TOKEN_REQUEST = 'FETCH_APP_TOKEN_REQUEST'
export const FETCH_APP_TOKEN_SUCCESS = 'FETCH_APP_TOKEN_SUCCESS'
export const FETCH_APP_TOKEN_FAILURE = 'FETCH_APP_TOKEN_FAILURE'
export const FETCH_APP_TOKEN = 'FETCH_APP_TOKEN'
export const CLEAR_APP_TOKEN = 'CLEAR_APP_TOKEN'
export const LOGIN_AS_MANAGER = 'LOGIN_AS_MANAGER'

export const FETCH_FUEL_TRACKERS_REQUEST = "FETCH_FUEL_TRACKERS_REQUEST"
export const FETCH_FUEL_TRACKERS_SUCCESS = "FETCH_FUEL_TRACKERS_SUCCESS"
export const FETCH_FUEL_TRACKERS_FAILURE = "FETCH_FUEL_TRACKERS_FAILURE"
export const FETCH_FUEL_TRACKER_REQUEST = "FETCH_FUEL_TRACKER_REQUEST"
export const FETCH_FUEL_TRACKER_SUCCESS = "FETCH_FUEL_TRACKER_SUCCESS"
export const FETCH_FUEL_TRACKER_FAILURE = "FETCH_FUEL_TRACKER_FAILURE"
export const CREATE_FUEL_TRACKER_REQUEST = "CREATE_FUEL_TRACKER_REQUEST"
export const CREATE_FUEL_TRACKER_SUCCESS = "CREATE_FUEL_TRACKER_SUCCESS"
export const CREATE_FUEL_TRACKER_FAILURE = "CREATE_FUEL_TRACKER_FAILURE"
export const DELETE_FUEL_TRACKER_REQUEST = "DELETE_FUEL_TRACKER_REQUEST"
export const DELETE_FUEL_TRACKER_SUCCESS = "DELETE_FUEL_TRACKER_SUCCESS"
export const DELETE_FUEL_TRACKER_FAILURE = "DELETE_FUEL_TRACKER_FAILURE"
export const UPDATE_FUEL_TRACKER_REQUEST = "UPDATE_FUEL_TRACKER_REQUEST"
export const UPDATE_FUEL_TRACKER_SUCCESS = "UPDATE_FUEL_TRACKER_SUCCESS"
export const UPDATE_FUEL_TRACKER_FAILURE = "UPDATE_FUEL_TRACKER_FAILURE"
export const CLEAR_FUEL_TRACKER_STATES = "CLEAR_FUEL_TRACKER_STATES"



// WEBPACK FOOTER //
// ./src/constants.js